"use client";

import { Button } from "app/_components/components/Button";
import { useTranslations } from "i18n";
import Link from "next/link";

export function MarsLPTakeoverSignupButton() {
  const t = useTranslations("homepage");
  return (
    <Button variant="primary" asChild id="register-exchange" size="lg">
      <Link target="_blank" href="https://exchange.gemini.com/register">
        {t("heroSignupText")}
      </Link>
    </Button>
  );
}
